export const createLogger = label => {
  return {
    error: error => {
      if (
        process.env.REACT_APP_ENVIRONMENT === 'production' &&
        window.newrelic
      ) {
        window.newrelic.noticeError(error);
      }

      if (console && console.log) {
        console.log(`error:${label}`);
        console.log(error);
      }
    },
  };
};
